import React, { useRef, useState } from 'react';
import Button from '../buttons/Button';

const MultipleFileInput = ({
  label = 'Escolher arquivos...',
  buttonText = 'ADICIONAR',
  name = 'documents',
  onFileSelect,
  required = false,
  disabled = false,
  accept = '.xls,.xlsx,.pdf,.jpg,.jpeg,.csv,.doc,.docx,.zip',
}) => {
  const fileInputRef = useRef();
  const [fileNames, setFileNames] = useState([]);

  const handleButtonClick = () => {
    if (!disabled) fileInputRef.current?.click();
  };

  const handleChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      setFileNames(files.map((f) => f.name));
      if (onFileSelect) onFileSelect(files);
    }
    e.target.value = '';
  };

  return (
    <div className="flex items-center gap-3">
      <div
        className={`flex-1 border border-bluePale rounded-xl px-3 py-3 text-base text-blueDarker bg-white cursor-pointer truncate ${
          disabled && 'opacity-50 cursor-not-allowed'
        }`}
        onClick={handleButtonClick}
        title={fileNames.join(', ') || label}
      >
        {fileNames.length > 0 ? fileNames.join(', ') : label}
      </div>

      <input
        type="file"
        ref={fileInputRef}
        name={name}
        onChange={handleChange}
        accept={accept}
        required={required}
        disabled={disabled}
        multiple
        className="hidden"
      />

      <Button disabled={disabled} type="button" onClick={handleButtonClick}>
        {buttonText}
      </Button>
    </div>
  );
};

export default MultipleFileInput;
